import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';

import { sessionSelectors } from '../../../../../../app/resource/session/session.selectors';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';
import { IOtherCommentsProps } from './types';
import { updateSession } from '../../../../../../app/page/page-storage/sessions/sessions.actions';
import { useDispatch } from 'react-redux';
import { meetingSimpleSelectors } from '../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { hasUserElevatedPrivilegesDuringSession } from '../../../../../../utils/user.utils';

export const OtherComments: FunctionComponent<IOtherCommentsProps> = ({ sessionId, loggedUserId }) => {
  const dispatch = useDispatch();
  const session = useSelectWithParams(sessionSelectors.selectResourceById, sessionId);
  const meetingId = session?.meetingId;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId ?? '');

  const [text, setText] = useState(session ? session.note : '');

  useEffect(() => {
    if (session) {
      setText(session.note);
    }
  }, [session]);

  const saveSession = useCallback(() => {
    dispatch(updateSession(sessionId, { note: text }));
  }, [dispatch, sessionId, text]);

  const hasElevatedPrivileges = hasUserElevatedPrivilegesDuringSession(loggedUserId, session, meeting);

  return (
    <div className="row mb-25 mt-3" style={{ width: '100%' }}>
      <div className="col-12">
        <div className="panel vto-text">
          <div className="panel-header no-border">
            <h2 className="bold">Other Comments</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <form className="panel-body pt-0">
                <div className="border-radius-1 lightGray-bg px-2 py-1">
                  <textarea
                    className="recap-textarea"
                    disabled={hasElevatedPrivileges === false}
                    placeholder="Based on this meeting, who needs to know what?"
                    value={text}
                    onChange={(event) => setText(event.target.value)}
                    onBlur={saveSession}
                  />
                </div>
                {/* <div className="recap-submit">
                  {!showLoader && (
                    <button type="button" className="btn green-bg" onClick={saveSession}>
                      Save Your Notes
                    </button>
                  )}
                  {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={30} width={30} />}
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
